import * as React from 'react';

import * as Yup from 'yup';
import { withFormik, FormikProps, Form, Field } from 'formik'; // removed FormikErrors **
import FormikTextField from '../../common/formik/formik-text-field';

import { bindActionCreators, Dispatch, compose } from 'redux';
import { connect } from 'react-redux';
import { IStore } from '../../modules/root-reducer';
import { Redirect } from 'react-router-dom';
import { ILoginData } from '../../@types';

import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import FormHelperText from '@material-ui/core/FormHelperText';
import Grid from '@material-ui/core/Grid';

import * as actions from '../../modules/login/action';

// Props for the form
interface ILoginProps {
  login: (values: ILoginData) => Promise<any>;
  loggedIn: boolean;
  loginErrors: {
    login: string;
  };
}

const formikEnhancer = withFormik<ILoginProps, ILoginData>({
  mapPropsToValues: () => {
    return {
      email: '',
      password: ''
    };
  },
  validationSchema: Yup.object().shape({
    email: Yup.string().required('Email is required to login'),
    password: Yup.string().required('Password is required to login')
  }),
  handleSubmit: (values, { setSubmitting, props }) => {
    return props.login(values).then(
      () => {
        setSubmitting(false);
      },
      () => {
        setSubmitting(false);
      }
    );
  }
});

const Login = (props: FormikProps<ILoginData> & ILoginProps) => {
  const { isSubmitting, loggedIn, loginErrors } = props;
  const errorMessage = loginErrors.login;

  if (loggedIn) {
    return (
      <Redirect to={{ pathname: '/customers', state: { from: '/login' } }} />
    );
  }

  return (
    <Grid container justify="center" alignItems="center">
      <Grid item xs={8} md={3}>
        <Typography variant="h6" align="center">
          Login
        </Typography>
        <Form>
          <div>
            <Field
              id="email"
              fullWidth
              name="email"
              label="Email"
              component={FormikTextField}
            />
          </div>
          <div>
            <Field
              fullWidth
              id="password"
              name="password"
              label="Password"
              component={FormikTextField}
              type="password"
            />
          </div>

          <Grid container justify="center" direction="column">
            <Button
              id="login"
              variant="contained"
              color="primary"
              type="submit"
              disabled={isSubmitting}
            >
              Login
            </Button>

            {errorMessage && (
              <FormHelperText error>{errorMessage}</FormHelperText>
            )}
          </Grid>
        </Form>
      </Grid>
    </Grid>
  );
};

const mapStateToProps = (state: IStore) => ({
  loggedIn: state.loginReducer.loggedIn,
  loginErrors: state.loginReducer.errors
});

const mapDispatchToProps = (dispatch: Dispatch<actions.LoginAction>) => {
  return bindActionCreators({ login: actions.login }, dispatch);
};

const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  formikEnhancer
);

export default enhance(Login);



// WEBPACK FOOTER //
// ./src/features/login/login.tsx